export default "__VITE_ASSET__DDd8wsid__"